/**
 * Identifies whether the current entry contributes to the trade or transaction economics, i.e. affects NetMoney(118).
 * tag: 2712
 * @readonly
 * @enum {number} (int)
 */
export enum MiscFeeQualifier {
  Contributes = 0,
  DoesNotContribute = 1,
}
